module.exports = __webpack_public_path__ + "img/cashback.78685129.png";